/**
 * KVKK yardımcıları (F9): telefon maskeleme + admin aracında serbest girilen
 * numarayı E.164'e çevirme. Worker (audit maskeleme, silme aracı) ve admin
 * arayüzü aynı kuralı kullanır.
 */

/** E.164 telefon — `phoneSchema` ile aynı biçim (metin içinde arama için global). */
const E164_IN_TEXT = /\+[1-9]\d{6,14}/g;

/** `+905551234567` → `+90******4567` (ülke kodu + son 4 hane görünür). */
export function maskPhone(e164: string): string {
  if (e164.length <= 7) return e164.replace(/\d(?=\d{2})/g, "*");
  return `${e164.slice(0, 3)}${"*".repeat(e164.length - 7)}${e164.slice(-4)}`;
}

/** Metindeki (ör. audit metadata JSON'u) tüm E.164 numaralarını maskeler. */
export function maskPhonesInText(text: string): string {
  return text.replace(E164_IN_TEXT, maskPhone);
}

/**
 * Admin'in yazdığı numarayı E.164'e çevirir: `0555 123 45 67`,
 * `5551234567`, `90 555…`, `+90 (555) …` → `+905551234567`.
 * Türkiye dışı numaralar `+` ile yazılmalı. Geçersizse `null`.
 */
export function toE164Loose(input: string): string | null {
  const raw = input.trim();
  const digits = raw.replace(/[^\d]/g, "");
  let e164: string;
  if (raw.startsWith("+")) e164 = `+${digits}`;
  else if (raw.startsWith("00")) e164 = `+${digits.slice(2)}`;
  else if (digits.length === 11 && digits.startsWith("0")) e164 = `+90${digits.slice(1)}`;
  else if (digits.length === 10 && digits.startsWith("5")) e164 = `+90${digits}`;
  else if (digits.length === 12 && digits.startsWith("90")) e164 = `+${digits}`;
  else return null;
  return /^\+[1-9]\d{6,14}$/.test(e164) ? e164 : null;
}

/** Silme aracının telefon yerine yazdığı tekil yer tutucu (UNIQUE(wedding_id, phone_e164) bozulmaz). */
export const ERASED_PHONE_PREFIX = "erased:";

/** Admin KVKK aracı — telefonla bulunan kayıtların özeti. */
export interface PrivacyLookupGuest {
  id: string;
  weddingSlug: string;
  weddingTitle: string | null;
  name: string | null;
  isDeleted: boolean;
  createdAt: string;
  media: number;
  comments: number;
  likes: number;
  rsvp: number;
  smsSends: number;
}

export interface PrivacyLookup {
  phoneMasked: string;
  guests: PrivacyLookupGuest[];
  authCodes: number;
  /** `null` = teklif tablosu henüz yok (migration 052 uygulanmamış). */
  contactRequests: number | null;
  organizers: number;
  /** Siparişler — vergi mevzuatı gereği SİLİNMEZ, yalnız bilgi. `null` = tablo yok (053). */
  orders: number | null;
  auditRows: number;
}

export interface PrivacyEraseResult {
  phoneMasked: string;
  guests: number;
  media: number;
  comments: number;
  likes: number;
  rsvp: number;
  smsSendsMasked: number;
  authCodes: number;
  contactRequests: number | null;
  auditRowsMasked: number;
}
